import { NativeModules } from 'react-native';

const { ThalesPaysdkWrapper, PayModule } = NativeModules;

//const { PayModule } = NativeModules;

export { ThalesPaysdkWrapper, PayModule};
//export default ThalesPaysdkWrapper;
//export default ThalesPaysdkWrapper as ThalesPaysdkWrapperType;
 